import React, { useEffect, useState } from 'react';
import SimpleBar from 'simplebar-react';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import { TransitionProps } from '@mui/material/transitions';
import Typography from '@mui/material/Typography';

import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import ButtonMenu from 'src/components/quotations/ButtonMenu';
import QuotationContent, {
  DataType,
  optionBtnPrint,
} from 'src/components/quotations/QuotationContent';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction='left' ref={ref} {...props} />;
});

interface DialogDetailProps {
  open: boolean;
  patientId: number;
  id: number;
  onClose: (isRefreshList?: boolean) => void;
  onSave?: () => void;
  openFormPayment: (info: any) => void;
  openFormQuote: (info: any) => void;
}

const DialogDetail: React.FC<DialogDetailProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataId, setDataId] = useState<DataType>({
    patientId: 0,
    id: 0,
  });
  const [screenPrint, setScreenPrint] = useState<number>(0);
  const [patientSelect, setPatientSelect] = useState<number | null>(null);
  const [fullData, setFullData] = useState<boolean>(false);

  const handleClickBtnPrint = (id: number) => {
    setScreenPrint(id);
    setTimeout(() => {
      setScreenPrint(0);
    }, 1000);
  };

  const handleClickPayment = () => {
    const data = {
      paymentid: 0,
      patientid: props.patientId,
      caseid: 0,
      quoteid: props.id
    };

    props.openFormPayment(data);
  };

  const handleButtonClick = () => {
    const data = {
      patientid: props.patientId,
      quoteid: props.id,
    };
    props.openFormQuote(data);
  };

  const handleClose = () => {
    props.onClose();
  };

  useEffect(() => {
    setLoading(true);
    if (props.open) {
      setDataId({
        patientId: props.patientId,
        id: props.id,
      });
      setLoading(false);
    } else {
      setScreenPrint(0);
      setDataId({
        patientId: 0,
        id: 0,
      });
    }
    // eslint-disable-next-line
  }, [props.open]);

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      slotProps={{ backdrop: { invisible: true } }}
      TransitionComponent={Transition}
      sx={{
        position: 'fixed !important',
        top: '0px !important',
        right: '0px !important',
        left: 'auto',
        bottom: 'auto',
        p: '0px',
        '& .MuiDialog-paper': {
          m: '0px !important',
          width: '788px',
          maxWidth: '788px',
          maxHeight: '100vh',
          bgcolor: '#FAFDFF',
          borderRadius: '16px 0px 0px 16px',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '24px', pb: '0px' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography
            sx={{ fontSize: '20px', lineHeight: '24px', fontWeight: 500 }}
          >
            見積書
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 10px 24px 24px',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
          overflow: 'hidden',
        }}
      >
        <SimpleBar
          style={{ height: 'calc(100vh - 150px)', borderWidth: '18px' }}
        >
          <Box
            sx={{
              pr: '14px',
            }}
          >
            <QuotationContent data={dataId} screenPrint={screenPrint} setPatientSelect={setPatientSelect} setFullData={setFullData}/>
          </Box>
        </SimpleBar>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'right',
          padding: '16px',
        }}
      >
        {patientSelect && (
          <BtnOutlineGradient
            text='入金'
            handleButtonClick={handleClickPayment}
            disabled={loading}
          />
        )}
        <ButtonMenu
          options={optionBtnPrint}
          onClick={handleClickBtnPrint}
          text='印刷'
          disabled={!fullData}
        />
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={handleClose}
          disabled={loading}
        />
        <BtnGradient
          text='登録'
          handleButtonClick={handleButtonClick}
          disabled={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogDetail;
